// ═══════════ INNER MOTION SYSTEM ═══════════
// Brand: Inner | From within.
// Subtle, ethereal, premium animations

document.addEventListener('DOMContentLoaded', function() {

  // Respect reduced motion preference
  var prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (prefersReducedMotion) return;

  // Detect product page — do NOT apply scroll reveal on product pages
  var mainContent = document.querySelector('#MainContent');
  var isProductPage = (mainContent && mainContent.getAttribute('data-template') === 'product');

  // 1. Scroll Reveal Observer — only on non-product pages
  if (!isProductPage) {
    var revealObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
        }
      });
    }, { threshold: 0.1, rootMargin: '0px 0px -40px 0px' });

    document.querySelectorAll('section, .hero, [class*="hero"]').forEach(function(el) {
      if (!el.closest('header') && !el.closest('nav')) {
        el.classList.add('inner-reveal');
        revealObserver.observe(el);
      }
    });

    // Ethereal fade for headings — soft, slow, blurred entrance
    var headingObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          headingObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -60px 0px' });

    document.querySelectorAll('h1, h2, h3, h4, h5, h6').forEach(function(el) {
      if (!el.closest('header') && !el.closest('nav') && !el.closest('footer')) {
        el.classList.add('inner-reveal-heading');
        headingObserver.observe(el);
      }
    });
  }

  // 2. Stagger product cards in collection grids (not on product page)
  if (!isProductPage) {
    document.querySelectorAll('[class*="product-list"], [class*="collection"]').forEach(function(grid) {
      var cards = grid.querySelectorAll('[class*="product-card"], [class*="card"]');
      cards.forEach(function(card, i) {
        card.style.transitionDelay = (i * 0.08) + 's';
      });
    });
  }

  // 3. Scroll Progress Bar
  var progressBar = document.createElement('div');
  progressBar.className = 'inner-scroll-progress';
  document.body.prepend(progressBar);

  window.addEventListener('scroll', function() {
    var scrollTop = window.scrollY;
    var docHeight = document.documentElement.scrollHeight - window.innerHeight;
    var scrollPercent = (scrollTop / docHeight) * 100;
    progressBar.style.width = scrollPercent + '%';
  });

  // 4. Image load class (no opacity manipulation — just marks loaded state)
  document.querySelectorAll('img').forEach(function(img) {
    if (img.complete) {
      img.classList.add('loaded');
    } else {
      img.addEventListener('load', function() { img.classList.add('loaded'); });
    }
  });

  // 5. Add to cart button animation (only outside product form to avoid conflicts)
  if (!isProductPage) {
    document.querySelectorAll('[class*="add-to-cart"], form[action*="/cart/add"] button').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var self = this;
        self.style.transform = 'scale(1.05)';
        setTimeout(function() { self.style.transform = 'scale(1)'; }, 300);
      });
    });
  }

  // 6. Product page: preload variant images on hover for faster switching
  if (isProductPage) {
    document.querySelectorAll('variant-picker input[type="radio"], variant-picker button').forEach(function(el) {
      el.addEventListener('mouseenter', function() {
        // Find the variant's product URL and preload the section
        var option = this.closest('[data-variant-id]') || this;
        var variantId = option.dataset?.variantId || option.dataset?.optionValueId;
        if (!variantId) return;

        // Preload the variant's images by hinting the browser
        var productImages = document.querySelectorAll('[class*="media-gallery"] img[srcset]');
        productImages.forEach(function(img) {
          // Touch the srcset to prompt browser to keep connection warm
          if (img.srcset) {
            var link = document.createElement('link');
            link.rel = 'prefetch';
            link.href = img.src;
            if (!document.querySelector('link[href="' + link.href + '"]')) {
              document.head.appendChild(link);
            }
          }
        });
      }, { passive: true });
    });
  }

  // 7. Smooth anchor scrolling
  document.querySelectorAll('a[href^="#"]').forEach(function(anchor) {
    anchor.addEventListener('click', function(e) {
      var target = document.querySelector(this.getAttribute('href'));
      if (target) {
        e.preventDefault();
        target.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    });
  });

});
